import Vue from "vue";
import om from "@/api";
import Vuex from "vuex";
import moment from "moment";
import router from "@/router";
import queryString from "query-string";
import storePublisherPlugin from "./plugins";
import { paquetesBeneficios } from "@/config/constantes/paquetesBeneficios";

Vue.use(Vuex);

const getSearchString = () => {
  // Como tenemos un hash en la URL, location.search no siempre funciona
  if (location.search) {
    // Tenemos search, usamos eso
    return location.search;
  }

  if (location.href.indexOf("?") !== -1) {
    // Tenemos variables en la URL después del hash. Intentar obtener.
    let splitHref = location.href.split("/");
    return splitHref[splitHref.length - 1];
  }

  return "";
};

const getFechaNacimiento = (searchQuery) => {
  let dia = searchQuery.hr_fechaNacDia
    ? ("00" + searchQuery.hr_fechaNacDia).slice(-2)
    : false;
  let mes = searchQuery.hr_fechaNacMes
    ? ("00" + searchQuery.hr_fechaNacMes).slice(-2)
    : false;
  let ano = searchQuery.hr_fechaNacAnio
    ? ("0000" + searchQuery.hr_fechaNacAnio).slice(-4)
    : false;

  if (dia && mes && ano) {
    return `${dia}/${mes}/${ano}`;
  }
  return "";
};

const searchQuery = queryString.parse(getSearchString());

const store = new Vuex.Store({
  plugins: [storePublisherPlugin],
  state: {
    isLoading: false,
    tcode: "",
    tna1MM: "",
    cark: null,
    error: {},
    simulacion: {
      selected: "fechaVto",
      fecha: "",
      dias: "",
      cp: "",
      plazo: "plazoDias",
      message: "$0",
      picked: "Fechas Dias",
      importeTotal: "",
      tasa: "",
      montoIntereses: "",
      cliente: "si",
      moneda: "pesos",
    },
    datosPersonales: {
      nombre: "",
      apellido: "",
      nroDocumento: "",
      sexo: "",
      nroTramite: "",
      email: "",
    },
    datosLaborales: {
      situacionLaboral: "001",
      actividad: "47",
      ocupacion: "07",
    },
    datosActividad: {
      pepRadio: "",
      requiredSubject: "",
    },
    datosCuenta: {
      tipoDoc: searchQuery.hr_tipoDoc || "00",
      numeroDoc: searchQuery.hr_numeroDoc || "",
      alias: "",
      sexo: searchQuery.hr_sexo || "",
      nroTramite: "",
      cbu: "",
      banco: "",
      nombre: "",
      apellido: "",
      cuil: "",
      tipoClave: "01",
      tipoClaveLabel: "CUIL",
      codigoError: "",
      valid: "",
      aliascbu: "",
      dniCuilIguales: "",
    },
    consultaAlias: {
      clienteBBVA: false,
    },
    datosRenaper: {
      provincia: "",
      fechaNacimiento: "",
      codigoPostal: "",
      ciudad: "",
      municipalidad: "",
    },
    validacionDeDatos: {
      imagen: "",
      isLoad: "false",
    },
    consulta: {
      nombre: searchQuery.hr_nombre || "",
      apellido: searchQuery.hr_apellido || "",
      tipoDoc: searchQuery.hr_tipoDoc || "00",
      numeroDoc: searchQuery.hr_numeroDoc || "",
      nacionalidad: searchQuery.hr_nacionalidad || "80",
      sexo: searchQuery.hr_sexo || "",
      fechaNacimiento: getFechaNacimiento(searchQuery),
      email: searchQuery.hr_email || "",
      celular: {
        area: searchQuery.hr_area || "",
        numero: searchQuery.hr_numero || "",
      },
      captcha: "",
      tipoResidencia: "",
      leadGenId: "",
    },
    oferta: {
      valid: false,
    },
    paquetesBeneficios: {},
    paso1: {
      situacionLaboral: "001",
      actividad: "47",
      ocupacion: "07",
    },
    paso2: {
      situacionLaboral: "001",
      actividad: "47",
      ocupacion: "07",
      ingresoNeto: "+25001",
    },
    paso3: {
      selectDomicilio: "particular",
      sucursal: "0005",
      domicilioEntrega: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        cp: "",
        localidad: "",
        provincia: "01",
      },
      tipoPago: "total",
      resumenDigital: true,
      resumenDigitalEmail: "",
    },
    paso4: {
      selectDomicilio: "particular",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        cp: "",
        localidad: "",
        provincia: "01",
      },
      otroDomicilio: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        cp: "",
        localidad: "",
        provincia: "01",
      },
      fecha: moment(new Date(), "YYYYMMDD").format("DD/MM/YYYY"),
      hora: "23:27 hs.",
    },
    route: null,
    trackClickElement: null,
    trackOnClickStart: null,
  },
  getters: {
    getDatosCuenta: (state) => () => state.datosCuenta,
    getDatosPersonales: (state) => () => state.datosPersonales,
    getValidacionDeDatos: (state) => () => state.validacionDeDatos,
    getDatosLaborales: (state) => () => state.datosLaborales,
    getSimulacion: (state) => () => state.simulacion,
    getDatosActividad: (state) => () => state.datosActividad,
    getDatosRenaper: (state) => () => state.datosRenaper,
    getConsulta: (state) => () => state.consulta,
    getConsultaAlias: (state) => () => state.consultaAlias,
    getOferta: (state) => () => state.oferta,
    getPaquetesBeneficios: (state) => () => state.paquetesBeneficios,
    getTna1MM: (state) => () => state.tna1MM,
    getPaso1: (state) => () => state.paso1,
    getPaso2: (state) => () => state.paso2,
    getPaso3: (state) => () => state.paso3,
    getPaso4: (state) => () => state.paso4,
    getRoute: (state) => () => state.route,
    getError: (state) => () => state.error
  },
  mutations: {
    onAtrasPepSosi(state) {
      (state.simulacion.fecha = ""),
        (state.simulacion.dias = ""),
        (state.simulacion.cp = ""),
        (state.simulacion.plazo = "plazoDias"),
        (state.simulacion.message = "$0"),
        (state.simulacion.picked = "Fechas Dias"),
        (state.simulacion.importeTotal = ""),
        (state.simulacion.tasa = ""),
        (state.simulacion.montoIntereses = ""),
        (state.importe = "");
    },
    onConsultaAlias(state, payload) {
      state.consultaAlias = payload;
    },
    onControlarCuitCbu(state, payload) {
      state.datosCuenta.valid = payload;
    },
    onControlarCuitAlias(state, payload) {
      state.datosCuenta.valid = payload;
    },
    onControlarDniCuil(state, payload) {
      state.datosCuenta.dniCuilIguales = payload;
    },
    onErrorInesperado(state, payload) {
      state.datosCuenta = payload;
    },
    onTCode(state, payload) {
      state.tcode = payload;
    },
    onConsultaTNA1mm(state, payload) {
      state.tna1MM = payload;
    },
    onConsulta(state, payload) {
      state.consulta = payload;
    },
    onDatosLaborales(state, payload) {
      state.paso1 = payload;
      om.pasoCA(state.cark, "datosLaborales", state);
    },
    onDatosPersonales(state, payload) {
      state.datosPersonales = payload;
    },
    onDatosRenaper(state, payload) {
      state.datosRenaper = payload;
    },
    onOferta(state, payload) {
      state.oferta = payload;
      state.paquetesBeneficios = paquetesBeneficios(payload.paquetes[0]);
      om.pasoCA(state.cark, "oferta", state);
    },
    onPaso1(state, payload) {
      state.paso1 = payload;
      om.pasoCA(state.cark, "paso1", state);
    },
    onPaso2(state, payload) {
      state.paso2 = payload;
      om.pasoCA(state.cark, "paso2", state);
    },
    onPaso3(state, payload) {
      state.paso3 = payload;
      om.pasoCA(state.cark, "paso3", state);
    },
    onPaso4(state, payload) {
      state.paso4 = payload;
      // En este paso ya no es necesario ya que el siguiente es gracias
      //om.pasoCA(state.cark, 'paso4', state)
    },
    onRoute(state, payload) {
      state.route = payload;
    },
    onClickTracking(state, payload) {
      state.trackClickElement = payload;
    },
    onClickStart(state, payload) {
      state.trackOnClickStart = payload;
    },
    onError(state, payload) {
      state.error = payload;
    },
    onCARK(state, payload) {
      state.cark = payload;
    },
    onIncommingCA(state, payload) {
      try {
        let caData = JSON.parse(payload.datos);

        // Los datos de consulta no...
        delete caData["consulta"];

        // En CA vienen objetos que estaban en el store.
        for (let paso in caData) {
          state[paso] = caData[paso];
        }
      } catch (e) {
        Vue.$log.error("No se pudo recuperar los datos de CA: " + e);
      }
    },
    onThank(state) {
      state.oferta.valid = false;
    },
    onIsLoading(state, payload) {
      state.isLoading = payload;
    },
    onCleanData(state) {
      state.simulacion.fecha = "";
      state.simulacion.dias = "";
      state.simulacion.importe = "";
      state.simulacion.plazo = "plazoDias";
    }
  },

  actions: {
    doAtrasPepSosi({ commit }) {
      router.push({
        name: "simulacion",
      });
      commit("onAtrasPepSosi");
    },

    // eslint-disable-next-line no-unused-vars
    doConfirmacionPF({ commit }, hash) {
      om.confirmacionPF(hash)
        .then((response) => {
          let respuesta = response.data;
          if (respuesta.status === "ERROR") {
            if (respuesta.respuesta === "clienteNoCensado") {
              router.push({
                name: "mensaje",
                params: {
                  mje: "mensaje-14",
                },
              });
            } else {
              router.push("errorInesperado");
            }
          } else if (respuesta.status === "OK" && !respuesta.respuesta.valid) {
            // Mensaje Invalido por datos invalidos servicio renaper
            router.push("mensajeInvalido");
          } else {
            //Ok Persona Valida
            router.push("thankyou");
          }
        })
        .catch(() => {
          router.push("errorInesperado");
        });
    },

    doControlarCuitCbu({ commit }, hash) {
      om.controlarCuitCbu(hash)
        .then((response) => {
          let data = response.data;
          if (data.respuesta.valid) {
            // El Cliente no es BBVA
            router.push({ name: hash.pasoSiguiente });
          } else {
            commit("onControlarCuitCbu", data.respuesta.valid);
          }
        })
        .catch(() => {
          router.push("errorInesperado");
        });
    },

    doControlarCuitAlias({ commit }, hash) {
      om.controlarCuitAlias(hash)
        .then((response) => {
          let data = response.data;
          if (data.respuesta.valid) {
            // El Cliente no es BBVA
            router.push({ name: hash.pasoSiguiente });
          } else {
            commit("onControlarCuitAlias", data.respuesta.valid);
          }
        })
        .catch(() => {
          router.push({ name: "errorInesperado" });
        });
    },

    doConsultaAlias({ commit, dispatch }, hash) {
      om.consultarAlias(hash).then((response) => {
        let data = response.data;
        if (data.respuesta === "INACTIVA") {
          commit("onControlarCuitAlias", false);
        } else if (data.respuesta.esCliente === "true") {
          commit("onConsultaAlias", { clienteBBVA: true });
        } else {
          let body = {
            alias: store.state.datosCuenta.alias,
            cuit: store.state.datosCuenta.cuil.split("-").join(""),
            pasoSiguiente: "confirmacion",
          };
          dispatch("doControlarCuitAlias", body);
        }
      }).catch(() => {
        router.push({ name: "errorInesperado" });
      });
    },

    doConsultaTNA1mm(context, payload) {
      context.commit("onConsultaTNA1mm", payload);
    },

    doTCode(context, payload) {
      context.commit("onTCode", payload);
    },

    doConsultaHash({ commit }, hash) {
      om.consultaHash(hash)
        .then((response) => {
          let respuesta = response.data;
          if (respuesta.status === "ERROR") {
            commit("onError", respuesta);
            router.push({
              name: "mensaje",
              params: {
                mje: "mensaje-4",
              },
            });
            return;
          }
          let consulta = respuesta.respuesta.consulta;

          // Pongo el hash en el scope global
          window.hash = consulta ? consulta.hash : "";

          let payload = {
            nombre: consulta.nombre,
            apellido: consulta.apellido,
            tipoDoc: consulta.tipoDoc,
            numeroDoc: consulta.nroDoc,
            nacionalidad: consulta.nacionalidad,
            sexo: consulta.sexo,
            fechaNacimiento: consulta.fechaNacimiento,
            email: consulta.email,
            celular: {
              area: consulta.tipoTel,
              numero: consulta.nroTel,
            },
            captcha: consulta.captchaResponse,
            tipoResidencia: "",
            leadGenId: consulta.leadGenId,
          };

          commit("onConsulta", payload);

          let oferta = respuesta.respuesta.oferta;

          if (oferta.tipoMje) {
            commit("onError", respuesta);
            router.push({
              name: "mensaje",
              params: {
                mje: oferta.tipoMje,
              },
            });
            return;
          }

          if (oferta.dictamen.toLowerCase() === "rechazado") {
            commit("onError", respuesta);
            router.push({
              name: "mensaje",
              params: {
                mje: "mensaje-3",
              },
            });
            return;
          }

          // Es una oferta
          oferta.valid = true;
          oferta.nroDeTramite = respuesta.respuesta.nroDeTramite;
          oferta.randomkey = respuesta.respuesta.randomkey;

          // Llamo al carro abandonado
          // Primero tengo que ir a buscar el CARandomKey
          let cark = oferta.carro;

          if (cark) {
            commit("onCARK", cark);

            om.obtenerCA(cark, (car) => {
              if (car.data && car.data.CA) {
                commit("onIncommingCA", car.data.CA);
              } else {
                Vue.$log.warn("No se pudo recuperar información del CA: ", car);
              }
            });
          }

          commit("onOferta", oferta);

          router.push("oferta");
        })
        .catch((error) => {
          commit("onError", error);
          router.push({
            name: "mensaje",
            params: {
              mje: "mensaje-4",
            },
          });
        });
    },
    doConsulta({ commit, state }, payload) {
      payload.tcode = state.tcode;
      commit("onConsulta", payload);

      om.consulta(payload)
        .then((response) => {
          let respuesta = response.data;
          let consulta = respuesta.respuesta.consulta;

          // Pongo el hash en el scope global
          window.hash = consulta ? consulta.hash : "";

          if (respuesta.status === "ERROR") {
            commit("onError", respuesta);
            router.push({
              name: "mensaje",
              params: {
                mje: "mensaje-4",
              },
            });
            return;
          }

          let oferta = respuesta.respuesta.oferta;

          if (oferta.tipoMje) {
            commit("onError", respuesta);
            router.push({
              name: "mensaje",
              params: {
                mje: oferta.tipoMje,
              },
            });
            return;
          }

          if (oferta.dictamen.toLowerCase() === "rechazado") {
            commit("onError", respuesta);
            router.push({
              name: "mensaje",
              params: {
                mje: "mensaje-3",
              },
            });
            return;
          }

          // Es una oferta
          oferta.valid = true;
          oferta.nroDeTramite = respuesta.respuesta.nroDeTramite;
          oferta.randomkey = respuesta.respuesta.randomkey;

          // Llamo al carro abandonado
          // Primero tengo que ir a buscar el CARandomKey
          let cark = oferta.carro;

          if (cark) {
            commit("onCARK", cark);

            om.obtenerCA(cark, (car) => {
              if (car.data && car.data.CA) {
                commit("onIncommingCA", car.data.CA);
              } else {
                Vue.$log.warn("No se pudo recuperar información del CA: ", car);
              }
            });
          }

          commit("onOferta", oferta);
          router.push("oferta");
        })
        .catch((error) => {
          commit("onError", error);
          router.push({
            name: "mensaje",
            params: {
              mje: "mensaje-4",
            },
          });
        });
    },

    doDatosLaborales(context, payload) {
      context.commit("onDatosLaborales", payload);
    },
    doDatosPersonales(context, payload) {
      context.commit("onDatosPersonales", payload);
      context.dispatch("doIsLoading", true);
      const sexo = payload.sexo === "femenino" ? "F" : "M";
      const hash = {
        nroDocumento: payload.nroDocumento,
        nroTramite: payload.nroTramite,
        sexo: sexo,
      };
      om.consultaRenaper(hash)
        .then((response) => {
          let data = response.data;
          context.dispatch("doIsLoading", false);
          if (data.status === "ERROR") {
            router.push("mensajeInvalido");
          } else {
            let datosRenaper = {
              provincia: data.respuesta.provincia,
              fechaNacimiento: data.respuesta.fechaNacimiento,
              codigoPostal: data.respuesta.codigoPostal,
              ciudad: decodeURI(escape(data.respuesta.ciudad)).toUpperCase(),
              municipalidad: decodeURI(
                escape(data.respuesta.municipalidad)
              ).toUpperCase(),
            };
            context.commit("onDatosRenaper", datosRenaper);
            if (payload.pasoSiguiente == "confirmacion") {
              router.push("confirmacion");
            } else {
              router.push("datosLaborales");
            }
          }
        })
        .catch(() => {
          context.dispatch("doIsLoading", false);
          router.push("mensajeInvalido");
        });
    },
    doPaso1(context, payload) {
      context.commit("onPaso1", payload);
    },
    doPaso2(context, payload) {
      context.commit("onPaso2", payload);
    },
    doPaso3(context, payload) {
      context.commit("onPaso3", payload);
    },
    doRoute(context, payload) {
      context.commit("onRoute", payload);
    },
    doClickTracking(context, payload) {
      // El evento de click solo debe trackearse con el primer elemento
      // que interactúa
      if (context.state.trackClickElement === null) {
        context.commit("onClickTracking", payload);
      }
    },
    doOnClickStart(context, payload) {
      context.commit("onClickStart", payload);
    },
    doThank(context, payload) {
      context.commit("onThank", payload);
    },
    doIsLoading(context, payload) {
      setTimeout(() => {
        // Detener loading al ingresar a ruta nueva
        // Lo hacemos en un timeout = 0 para hacer
        // al final del event loop
        context.commit("onIsLoading", payload);
      }, 0);
    },
    doCleanData(context) {
      context.commit("onCleanData");
    },
  },
});

export default store;
